import type { LucideProps } from "lucide-react";

import { LandmarkIcon, LockKeyholeIcon, NotebookTextIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";

const options = [
	{
		title: "Connect your bank Account",
		Icon: LandmarkIcon,
		description:
			"Connect bank account to easily fund your wallet and make easy payment",
		href: "/buyer/home"
	},
	{
		title: "Setup a security pin",
		Icon: LockKeyholeIcon,
		description: "Set up a security pin to authorise your payments",
		href: "/buyer/home"
	},
	{
		title: "Complete your KYC",
		Icon: NotebookTextIcon,
		description: "Complete your KYC, let's get to know you more",
		href: "/buyer/home"
	}
];

export const Route = createFileRoute("/get-started")({
	component: GetStartedPage
});

function GetStartedPage() {
	const navigate = useNavigate();

	return (
		<section className="relative min-h-screen w-full bg-primary px-4 py-8 text-background md:px-8">
			<div className="mx-auto max-w-4xl">
				<div className="relative mb-12 text-center">
					<h1 className="mb-2 text-3xl font-bold md:text-4xl">Get started</h1>
					<p className="text-lg text-background/80">Get the most out of Intasida by completing these few steps</p>
					<Button
						onClick={() => navigate({ to: "/buyer/home" })}
						variant="ghost"
						className="absolute right-0 top-0 border border-background/20 hover:bg-background/10"
					>
						Skip
					</Button>
				</div>
				<div className="mx-auto flex max-w-xl flex-col items-center justify-center space-y-6">
					{options.map(option => (
						<GetStartedCard key={option.title} {...option} />
					))}
				</div>
			</div>
		</section>
	);
}

function GetStartedCard({
	title,
	Icon,
	description,
	href
}: {
	title: string;
	Icon: React.ComponentType<LucideProps>;
	description: string;
	href: string;
}) {
	return (
		<Link to={href} className="w-full">
			<div className="flex w-full cursor-pointer items-center justify-start rounded-xl border border-background/20 bg-background/5 p-4 transition-all hover:bg-background/10 hover:shadow-lg">
				<div className="grid size-12 place-items-center rounded-full bg-background/10 p-2 md:size-14">
					<Icon className="size-6 md:size-7" />
				</div>
				<div className="ml-4 p-2">
					<h2 className="text-start text-lg font-semibold md:text-xl">{title}</h2>
					<p className="text-sm text-background/70 md:text-base">
						{description}
					</p>
				</div>
			</div>
		</Link>
	);
}
